import React from 'react';
import Navbar from '../../../components/AuctionFeatureComponents/Home/Navbar';
import '../../../assets/styles/Home.css';
import HeroBanner from '../../../components/AuctionFeatureComponents/Home/HeroBanner/HeroBanner';
import Introduction from '../../../components/AuctionFeatureComponents/Home/Introduction/Introduction';
import Features from '../../../components/AuctionFeatureComponents/Home/Features/Features';
import FAQs from '../../../components/AuctionFeatureComponents/Home/FAQs/FAQs';

const Home = () => {
  return (
    <>
      <Navbar />
      <div id="home">
        <HeroBanner />
        
        <Features />
        
        <FAQs />
        
        {/* Pricing Section */}
        <div className="content-section pricing-section">
          <h2 className="text-center">Simple, Transparent Pricing</h2>
          <p className="text-center">
            Choose the perfect plan for your auction needs
          </p>
          
          {/* Features included in all plans */}
          <div className="included-features-section">
            <h3 className="text-center">All plans include:</h3>
            <ul className="features-list">
              <li>Complete digital auction platform with real-time bidding</li>
              <li>Professional live streaming capabilities for remote participants</li>
              <li>Dynamic OBS overlay generation for enhanced broadcast experience</li>
              <li>Comprehensive player registration forms with team management</li>
              <li>Exciting live bidding animations and visual effects</li>
            </ul>
          </div>
          
          {/* Pricing Cards */}
          <div className="pricing-cards-container">
            <div className="pricing-card">
              <div className="pricing-card-header">
                <h3>Starter</h3>
                <h4>Free</h4>
              </div>
              <div className="pricing-card-body">
                <div className="pricing-limit">Up to 3 teams</div>
              </div>
            </div>
            
            <div className="pricing-card">
              <div className="pricing-card-header">
                <h3>Basic</h3>
                <h4>$100</h4>
              </div>
              <div className="pricing-card-body">
                <div className="pricing-limit">Up to 4 teams</div>
              </div>
            </div>
            
            <div className="pricing-card">
              <div className="pricing-card-header">
                <h3>Standard</h3>
                <h4>$150</h4>
              </div>
              <div className="pricing-card-body">
                <div className="pricing-limit">Up to 6 teams</div>
              </div>
            </div>
            
            <div className="pricing-card">
              <div className="pricing-card-header">
                <h3>Premium</h3>
                <h4>$200</h4>
              </div>
              <div className="pricing-card-body">
                <div className="pricing-limit">6-10 teams</div>
              </div>
            </div>
            
            {/* Customization Card */}
            <div className="pricing-card customization-card">
              <div className="pricing-card-header">
                <h3>Custom</h3>
                <h4>Contact Us</h4>
              </div>
              <div className="pricing-card-body">
                <div className="customization-content">
                  <p>Need more teams or special features?</p>
                  <p className="custom-email">
                    <a href="mailto:contact.myliveauction@gmail.com">contact.myliveauction@gmail.com</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="content-section need-help-section">
          <h2 className="text-center">Need Any Help?</h2>
          <p className="text-center">
            If you have any questions about our platform, need assistance setting up your first auction, or 
            require support with participating in an existing event, our team is here to help.
          </p>
          <p className="text-center">
            We provide comprehensive support to ensure you get the most out of our platform. Whether you're a 
            league organizer, team manager, or spectator, we're committed to making your experience seamless 
            and enjoyable.
          </p>
          
          <div className="contact-details-container">
            <div className="contact-row">
              <div className="contact-item">
                <h5>Email</h5>
                <p>contact.myliveauction@gmail.com</p>
              </div>

              <div className="contact-item">
                <h5>Support Timings</h5>
                <p>24*7</p>
              </div>
            </div>
          </div>
          
          <div className="text-center mt-4">
            <a href="/#footer" className="btn btn-primary btn-lg">
              Contact Us
            </a>
          </div>
        </div>
        
        {/* Footer */}
        <footer className="bg-dark text-white text-center py-4" id="footer">
          <div className="container">
            <hr className="my-4" style={{ borderColor: 'rgba(255,255,255,0.2)' }} />
            <p>© 2025 LiveAuction. All rights reserved.</p>
            <div className="footer-links">
              <a href="/privacy-policy">Privacy Policy</a> | 
              <a href="/terms-of-service"> Terms of Service</a> |
              <a href="/#footer"> Contact Us</a>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Home;